module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Diagnostics-9893e3c5d63693148bbc85d4bf37a2f7.svg";